import script from "./DriverCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./DriverCard.vue?vue&type=script&setup=true&lang=ts"

import "./DriverCard.vue?vue&type=style&index=0&id=89575afa&lang=css"

const __exports__ = script;

export default __exports__